module.exports = __webpack_public_path__ + "static/media/date_icon.7c802741.svg";